import i18next from 'i18next';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import { supportedLngs } from 'src/i18n';
import { useState, useEffect, createContext } from 'react';

const UserContext = createContext({});

const roleAccess = ['patient', 'app'];

export const UserProvider = ({ children }) => {
  const [lang, setLang] = useState(i18next.language);
  const [user, setUser] = useState();
  const [installPrompt, setInstallPrompt] = useState();
  const cookies = new Cookies();

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    });
  }, []);

  const processUser = (passedUser) => {
    // if there was a cached language, don't update with language from profile
    if (!cookies.get('language-cached')) modifyLanguage(passedUser?.language);
    setUser({
      ...passedUser,
      displayName: `${passedUser?.first_name} ${passedUser?.last_name}`,
      access: roleAccess,
    });
  };

  const modifyLanguage = (languageInput) => {
    if (languageInput) {
      let language = languageInput.split('-');
      language = language.length > 1 ? `${language[0]}-${language[1].toUpperCase()}` : language[0];

      if (supportedLngs.includes(language)) {
        i18next.changeLanguage(language);
        setLang(language);
      }
    }
  };

  return (
    <UserContext.Provider
      value={{
        lang,
        setLang: modifyLanguage,
        user,
        setUser: processUser,
        installPrompt,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;

UserProvider.propTypes = {
  children: PropTypes.any,
};
